<header class="background-header classic-background"></header>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container admin-dashboard-parent analytics-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Analytics'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Analytics</h1>
			</div>
		</section>

		<section class="user-dashboard">
			<div class="user-name">
				<h2 class="user-name" *ngIf="chosenTab == 'overview'">Overview</h2>
				<h2 class="user-name" *ngIf="chosenTab == 'acquisition'">Acquisition</h2>
				<h2 class="user-name" *ngIf="chosenTab == 'engagement'">Engagement</h2>
				<h2 class="user-name" *ngIf="chosenTab == 'retention'">Retention</h2>
			</div>
			<div class="user-navigation">
				<div class="overview" (click)="openTab($event, 'overview')"
					[ngClass]="{activeTab:chosenTab=='overview'}">
					<span>Overview</span>
				</div>
				<div class="acquisition" (click)="openTab($event, 'acquisition')"
					[ngClass]="{activeTab:chosenTab=='acquisition'}">
					<span>Acquisition</span>
				</div>
				<div class="engagement" (click)="openTab($event, 'engagement')"
					[ngClass]="{activeTab:chosenTab=='engagement'}">
					<span>Engagement</span>
				</div>
				<div class="retention" (click)="openTab($event, 'retention')"
					[ngClass]="{activeTab:chosenTab=='retention'}">
					<span>Retention</span>
				</div>
			</div>
		</section>

		<section class="user-analytics">
			<section class="tabcontent" id="overview" style="width:100%;">
			</section>
			<section class="tabcontent hide-category" id="acquisition" style="width:100%;">
				<!-- <canvas *ngIf="lineChartDataSets" baseChart [datasets]="lineChartDataSets" [labels]="pieLabels"
					[legend]="true" [chartType]="lineChartType" [colors]="donutColors" width="400px" height="300px">
				</canvas> -->
			</section>
			<section class="tabcontent hide-category" id="engagement" style="width:100%">
				<section style="width:40%;float:left;">
					<!-- <canvas *ngIf="planItemCountDataSets" baseChart [datasets]="planItemCountDataSets"
						[labels]="planItemCountLabels" [legend]="true" [chartType]="lineChartType"
						[colors]="donutColors">
					</canvas> -->
				</section>
				<section style="width:40%;float:left;margin-left:8%;">
					<!-- <canvas *ngIf="popularSectionsDataSets" baseChart [datasets]="popularSectionsDataSets"
						[labels]="popularSectionsLabels" [legend]="false" [chartType]="barChartType"
						[colors]="donutColors">
					</canvas> -->
				</section>
			</section>
			<section class="tabcontent hide-category" id="retention">4</section>
		</section>

	</section>
</section>